import React from "react";
import { Link } from "react-router-dom";

import classes from "./error.module.css";
const Error = () => {
  return (
    <div className={classes.pageContainer}>
      <div className={classes.pageRow}>
        <h2 className={classes.status}>404</h2>
        <p className={classes.errorMessage}>page not found</p>
        <Link to="/" className={classes.btn1}>
          Return to Home page
        </Link>
      </div>
    </div>
  );
};

export default Error;
